import { asyncLoadRouter } from '@router/helper'

const categories = [
  {
    path: 'categories',
    component: asyncLoadRouter('manager/organizations/Categories'),
    redirect: (to) => {
      return {
        name: 'manager-organizations-categories-edit',
        params: { organization_id: to.params.organization_id },
      }
    },
    meta: {
      breadcrumb: (i18n, params) => [
        {
          text: i18n.t('activerecord.models.category.other'),
          to: {
            name: 'manager-organizations-categories-edit',
            params: { organization_id: params.organization_id },
          },
        },
      ],
    },
    children: [
      {
        path: 'edit',
        name: 'manager-organizations-categories-edit',
        component: asyncLoadRouter('manager/organizations/categories/Form'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
        props: { action: 'update' },
      },
    ],
  },
]

export default categories
